import { useMemo } from "react";
import { useParams } from "react-router-dom";
import GameFrame from "@/components/games/GameFrame";

const GAME_META = {
  "runway-themes": { title: "Runway Themes" },
  "pocket-garden": { title: "Pocket Garden" },
  "kitten-cafe-merge": { title: "Kitten Café Merge" },
};

export default function GamePlayPage() {
  const { slug } = useParams();

  const meta = useMemo(() => {
    return GAME_META[slug] || { title: slug };
  }, [slug]);

  return (
    <GameFrame
      slug={slug}
      title={meta.title}
      difficulty={2}
      defaultMuted={true}
    />
  );
}
